import React from 'react';
import { ModuleBridge } from '../components';

export const ReportingDrPolicies = () => {
    return <ModuleBridge moduleId="reporting_dr_policies_module" />;
};
